import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { SplitText } from 'gsap/all';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { isAndroid } from '../_app/cuchillo/core/Basics';

const RANGES = { title: [0.2, 0.3], show: [0.3, isAndroid ? .6 : 0.75] };

class ScrollItem__StepText extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.resize();

        this._setupTitle(__link);
        this._setupUnits(__link);

        this.onMove = () => {
            const titleP = Maths.clamp(Maths.normalize(RANGES.title[1], RANGES.title[0], this.progressInside), 0, 1);
            this._drawTitle(titleP);

            const showP = Maths.clamp(Maths.normalize(RANGES.show[1], RANGES.show[0], this.progressInside), 0, 1);
            this._draw(showP);
        };
    }

    _setupTitle(__link) {
        this._titlLine = [];
        this._titleInc = 0;

        const titleEl = GetBy.class('label', __link)[0];
        if (!titleEl) return;

        this._titlLine = new SplitText(titleEl, {
            type: 'lines',
            linesClass: 'line-child'
        }).lines;

        this._titleInc = this._titlLine.length > 0 ? 1 / this._titlLine.length : 0;
        this._drawTitle(0);
    }

    _drawTitle(titleP) {
        let p0 = 0;
        let p1 = this._titleInc;

        for (let i = 0; i < this._titlLine.length; i++) {
            const vis = Maths.clamp(Maths.normalize(p1, p0, titleP), 0, 1);
            this._titlLine[i].style.transform = `translateY(${(1 - vis) * 100}%)`;
            p0 = p1;
            p1 += this._titleInc;
        }
    }

    _setupUnits(__link) {
        this._units = [];
        this.totalItems = 0;
        this.inc = 0;

        const container = GetBy.class("__textShow", __link)[0];
        if (!container) return;

        const words = new SplitText(container, {
            type: 'words',
            wordsClass: 'word-child'
        }).words;
        const wordUnits = words.map(el => ({
            type: 'word',
            el
        }));

        this._units = wordUnits.sort((a, b) =>
            (a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING)
                ? -1
                : 1
        );

        this.totalItems = this._units.length;
        this.inc = this.totalItems > 0 ? 1 / this.totalItems : 0;

        this._draw(0);
    }

    _draw(showP) {
        let p0 = 0;
        let p1 = this.inc;

        for (let i = 0; i < this.totalItems; i++) {
            const vis = Maths.clamp(
                Maths.normalize(p1, p0, showP),
                0,
                1
            );

            const u = this._units[i];
            u.el.style.opacity = vis;

            p0 = p1;
            p1 += this.inc;
        }
    }
}

Scroll._registerClass('StepText', ScrollItem__StepText);

export default ScrollItem__StepText;
